import { faCircleMinus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Space } from "antd";
import { func } from "prop-types";
import { itemType } from "./types";

const MinusListItem = ({ item, onItemRemove }) => {
  const handleClick = () => onItemRemove(item.id);

  return (
    <li>
      <Space>
        <FontAwesomeIcon
          icon={faCircleMinus}
          data-test-id={`minus-list-item${item.id}`}
          onClick={handleClick}
        />
        <span>{item.label}</span>
      </Space>
    </li>
  );
};

MinusListItem.propTypes = {
  onItemRemove: func.isRequired,
  item: itemType,
};

export default MinusListItem;
